export default {
  推荐好友加入: `친구 초대하기`,
  赢取巴塞罗那VIP之旅:'바르셀로나 <span class="vipWord">VIP</span> 여행의 주인공이 되어보세요 ',

  成为EBC推荐官: "EBC 금융그룹과 함께 더 나은 거래를 경험할 수 있도록, 지금 친구를 초대해보세요",
  立即参与: "지금 초대하기 ",
  专属奖励等你拿: "오직 당신을 위한 특별한 혜택",
  您将获得以下奖励:'2025년 5월 23일까지 친구 66명을 추천하고 다음 보상을 받으세요:',
  西班牙巴塞罗那之旅:'스페인 바르셀로나 프리미엄 여행 패키지',
  巴塞罗那足球俱乐部主场比赛VIP门票:'FC 바르셀로나 홈 경기 VIP 티켓',
  巴塞罗那足球俱乐部专属晚宴:'FC 바르셀로나 프라이빗 갈라 디너 초청',
  往返机票酒店住宿当地接送导服务:'왕복 항공권, 호텔 숙박, 현지 이동 및 가이드 투어 포함',
   如何赢取大奖:'참여 방법 안내',
  登录EBC用户中心: "EBC 고객 포털에 로그인",
  "进入“大赛推荐官”活动页面": '친구초대 이벤트" 클릭',
  生成您的邀请链接或二维码: "전용 링크 혹은 QR코드 생성",
  成功推荐66人: "66명 추천 성공",
成功推荐奖励:'추천이 인정되려면, 친구가 이벤트 기간 내 $500 이상 입금하고 최소 1건의 거래를 완료해야 합니다.',
  你还在等什么:'아직도 망설이고 계신가요?',
  EBC为交易者捉供更低点差:'EBC는 트레이더 여러분께 더 낮은 스프레드, 경쟁력 있는 리베이트 혜택, 그리고 다양한 전용 특전을 제공합니다.바르셀로나에서 여러분을 직접 만나 뵐 수 있기를 기대합니다.',
  每一次推荐: "한 번의 초대로 바르사를 향한 한 걸음을 내딛다",
  参与规则: "참여 방법",
  成为EBC推荐官并邀请66人: "EBC 초대자가 되어 66명의 친구를 초대하기",
  所有被邀请人均入金大于等于$500: `초대된 친구가 최소 $500을 입금하고 거래를 완료함`,
  参与方法: "참여 절차",
  立即推荐: "지금 바로 친구들을 초대하고 전설적인 순간을 함께 하세요",

  巴萨荣耀之旅: "FC 바르셀로나로 향하는 챔피언의 길",
  每笔订单都是攻守博弈的艺术: `대회 우승자는 FC 바르셀로나의 홈구장인 캄프 누에 초대됩니다.`,
  活动时间: "이벤트 기간",
  "2025年2月22日": "2025년 2월 22일 01:00:00 ~ 2025년 5월 23일 23:59:59 (MT4/MT5시간)",
  活动规则: "이벤트 규칙",
  ruleList: [
    `해당 이벤트는 "친구초대 이벤트" 및 다른 이벤트와 중복 진행 가능합니다. `,
    "초대된 친구가 입금 및 거래를 완료해야 하며, 제 3자의 이체는 무효 처리 됩니다.",
    "부정행위 적발 시 당사는 해당 참가자의 참가 자격을 박탈할 권리가 있습니다.",
    "추천을 통해 등록된 계정은 대리인을 이전할 수 없습니다.",
    "보상은 활성화된 계정을 기준으로 하며, VIP 관람석 초대에는 항공권과 숙박이 포함됩니다.",
    "본 이벤트의 최종 해석권은 EBC에 있습니다",
  ],
};
